import { Component, Input, OnInit } from '@angular/core';
import { statusClass } from 'src/app/model/constants';
import { DownloadApiService } from './api/download.api.service';
import { IDownloadApp } from './api/download.interface';



@Component({
  selector: 'app-download-app',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss']
})
export class DownloadAppComponent implements OnInit {

  constructor(
    private downloadApiService: DownloadApiService
  ) { }

  @Input() dwnapp: IDownloadApp;

  ngOnInit(): void {
    this.getAppPlaceHolder();
  }

  async getAppPlaceHolder(): Promise<void> {
    const appPlaceHolder  = await this.downloadApiService.getAppPlaceHolder().toPromise();
    if (appPlaceHolder.code === statusClass.overall_success_response) {
      this.dwnapp = appPlaceHolder.data;
      console.log(this.dwnapp );
    }
  }
}
